// src/pages/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';
import SEOHelmet from '../components/SEOHelmet';
import '../styles/pages/notFound.css';

const NotFound = () => {
    return (
        <>
            <SEOHelmet 
                title="Page Not Found"
                description="Sorry, the page you are looking for does not exist."
            />
            <div className="not-found">
                <div className="container">
                    <h1>404</h1>
                    <h2>Page Not Found</h2>
                    <p>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
                    
                    <div className="not-found-actions">
                        <Link to="/" className="btn btn-primary">Return Home</Link>
                        <Link to="/models" className="btn btn-secondary">Browse Models</Link>
                        <Link to="/photoshoots" className="btn btn-secondary">Browse Photoshoots</Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NotFound;

// Add to App.js in the Switch component:
